"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFilledEditableTextLayer = exports.filledEditableTextLayerRuleSet = exports.isEditableTextLayer = exports.editableTextLayerRuleSet = void 0;
exports.getEditableTextLayerS3Key = getEditableTextLayerS3Key;
exports.generateTextAssetId = generateTextAssetId;
exports.getEditableTextUrlForLayer = getEditableTextUrlForLayer;
const Layer_1 = require("./Layer");
const EditableTextDefaultData_1 = require("./EditableTextDefaultData");
const env_1 = require("../../utils/env");
const typeguard_1 = require("../../types/typeguard");
const md5_1 = __importDefault(require("crypto-js/md5"));
const EditableTextLayerUserData_1 = require("./EditableTextLayerUserData");
exports.editableTextLayerRuleSet = {
  type: typeguard_1.isNonEmptyString,
  defaultData: EditableTextDefaultData_1.isEditableTextDefaultData,
  textRestrictions: (0, typeguard_1.optional)(EditableTextDefaultData_1.isEditableTextRestriction),
  maxAllowedLines: (0, typeguard_1.optional)(typeguard_1.isNumber),
  userData: (0, typeguard_1.optional)(EditableTextLayerUserData_1.isEditableTextLayerUserData),
  linkedLayer: (0, typeguard_1.optional)(value => (0, typeguard_1.isType)(value, {
    id: typeguard_1.isNonEmptyString
  }))
};
const isEditableTextLayer = etl => (0, Layer_1.isLayer)(etl) && etl.type === 'editable_text' && (0, typeguard_1.isType)(etl, exports.editableTextLayerRuleSet);
exports.isEditableTextLayer = isEditableTextLayer;
function getEditableTextLayerS3Key(userId, projectId, assetId) {
  return `generatedImages/clientSide/${userId}/${projectId}/textAssets/${assetId}.png`;
}
function generateTextAssetId(layerWidth, layerHeight, content, printableSurface) {
  const {
    width: surfaceWidth,
    height: surfaceHeight
  } = printableSurface;
  const contentWithSurface = `${content}${Number(surfaceWidth.toFixed(3)) * layerWidth}${Number(surfaceHeight.toFixed(3)) * layerHeight}`;
  const hash = `${(0, md5_1.default)(contentWithSurface)}`;
  return hash;
}
function getEditableTextUrlForLayer(userId, projectId, assetId) {
  const s3BaseUrl = (0, env_1.getS3ImageBaseUrl)();
  if (!s3BaseUrl) {
    console.warn('s3BaseUrl not defined');
    return undefined;
  }
  return `${s3BaseUrl.value}/${getEditableTextLayerS3Key(userId, projectId, assetId)}`;
}
exports.filledEditableTextLayerRuleSet = Object.assign(Object.assign({}, exports.editableTextLayerRuleSet), {
  userData: EditableTextLayerUserData_1.isFilledEditableTextLayerUserData
});
const isFilledEditableTextLayer = l => (0, Layer_1.isLayer)(l) && (0, typeguard_1.isType)(l, exports.filledEditableTextLayerRuleSet);
exports.isFilledEditableTextLayer = isFilledEditableTextLayer;